export default __webpack_public_path__ + "static/media/pencil_edit.a4feb152.svg";